var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoomable-container",style:(_vm.containerStyle),on:{"touchstart":_vm.handleTouchStart,"touchmove":_vm.handleTouchMove,"touchend":_vm.handleTouchEnd,"wheel":_vm.handleWheel}},[_c('div',{staticClass:"zoomable-content",style:(_vm.contentStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }